module.exports = __webpack_public_path__ + "img/fossilImg2.441190a9.jpg";